import * as t from '../types';
import {GetContentNote} from '../../services'


export const getContentNoteAction = (slug) => async (dispatch) => {
    dispatch({
        type: t.GET_CONTENT_NOTE_REQUEST
    });

    return await GetContentNote(slug)

        .then((data) => {
            dispatch({
                type: t.GET_CONTENT_NOTE_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            dispatch({
                type: t.GET_CONTENT_NOTE_FAILED,
                payload: err.response
            });
        });
};
